function startCountingAnimation(counterElement) {
    const counterValue = counterElement.querySelector(".counter-value");
    const target = parseInt(counterElement.getAttribute("data-count"));

    if (counterElement.classList.contains("counting")) {
        // Animation has already run, set the final value and return
        counterValue.textContent = target;
        return;
    }

    counterElement.classList.add("counting");

    let count = 0;
    const increment = target / 100; // Change this value to control animation speed

    function updateCounter() {
        count += increment;
        counterValue.textContent = Math.floor(count);

        if (count < target) {
            requestAnimationFrame(updateCounter);
        } else {
            counterValue.textContent = target;
        }
    }

    updateCounter();
}

function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function onScroll() {
    const counterElements = document.querySelectorAll(".counter");
    counterElements.forEach((counter) => {
        if (isElementInViewport(counter)) {
            startCountingAnimation(counter);
        }
    });

    // Remove the scroll event listener after all counters have started
    if (document.querySelectorAll(".counter:not(.counting)").length === 0) {
        window.removeEventListener("scroll", onScroll);
    }
}

window.addEventListener("scroll", onScroll);
